import { render, staticRenderFns } from "./ToggleSwitchOff.vue?vue&type=template&id=2b703b10&functional=true&"
import script from "./ToggleSwitchOff.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitchOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports